import $ from 'jquery'

const initInputSpinner = (inputEl) => {
  const wrapper = inputEl.parentNode
  const minusBtn = wrapper.querySelector('.bhub-input-spinner__button--minus')
  const plusBtn = wrapper.querySelector('.bhub-input-spinner__button--plus')
  const min = inputEl.getAttribute('min')
  const max = inputEl.getAttribute('max')

  minusBtn.addEventListener('click', () => {
    const currentValue = parseInt(inputEl.value, 10)
    if (currentValue > min) {
      inputEl.value = currentValue - 1
      $(inputEl).trigger('change')
    }
  })

  plusBtn.addEventListener('click', () => {
    const currentValue = parseInt(inputEl.value, 10)
    if (currentValue < max) {
      inputEl.value = currentValue + 1
      $(inputEl).trigger('change')
    }
  })
}

export default initInputSpinner
